import React, { useEffect, useState } from "react";
import classes from "./Elligibility.module.scss";
import CustomImage from "../../CustomImage";
import useIsMobile from "../../../hooks/useIsMobile";

function Elligibility({ countryData }: { countryData: any }) {
  const isMobile = useIsMobile(768);
  const [activeTab, setActiveTab] = useState<string>("");
  const [eligibilityData, setEligibilityData] = useState<any>([]);
  const [filteredTabData, setFilteredTabData] = useState<any>([]);

  useEffect(() => {
    const tabs = countryData?.eligibility?.eligibilityTab ?? [];
    setActiveTab(tabs[0]?.name ?? "");
  }, [countryData]);

  useEffect(() => {
    let tempEligibilityData = countryData?.eligibility?.eligibilityTab ?? [];
    setEligibilityData(tempEligibilityData ?? []);

    let tempData = tempEligibilityData?.filter((tab: any) => tab?.name === activeTab);

    setFilteredTabData(tempData ?? []);
  }, [countryData, activeTab]);

  const handleTabClick = (tab: string) => () => {
    setActiveTab(tab);
  };

  return (
    <div id="eligibility" className={classes["elligibility-container"]}>
      <div className={classes["elligibility-card"]}>
        <h2 className={classes["elligibility-title"]}>{countryData?.eligibility?.title ?? ""}</h2>
        <div className={classes["elligibility-description"]} dangerouslySetInnerHTML={{ __html: countryData?.eligibility?.description ?? "" }}></div>

        <div className={classes["sub-card-container"]}>
          <div className={classes["tab-container"]}>
            {eligibilityData?.map((el: any) => (
              <button className={`${classes["tab-button"]} ${activeTab === el?.name && classes["active-tab"]}`} onClick={handleTabClick(el?.name)}>
                {el?.name}
              </button>
            ))}
          </div>

          <div className={classes["sub-card"]}>
            {filteredTabData[0]?.image?.url && (
              <div className={classes["sub-card-image"]}>
                <CustomImage
                  src={filteredTabData[0]?.image?.url}
                  alt="academic-qualifications"
                  width={135}
                  height={135}
                  objectFit="cover"
                  className={classes["image-wrapper"]}
                />
              </div>
            )}
            <div style={!isMobile && !filteredTabData[0]?.image?.url ? { padding: "0 24px" } : {}} className={classes["sub-card-content"]}>
              {isMobile && <p className={classes["sub-card-content-item-title"]}>{filteredTabData[0]?.name ?? ""}</p>}

              <div className={classes["sub-card-content-item"]}>
                {filteredTabData[0]?.title1 && <h3 className={classes["sub-card-content-item-title"]}>{filteredTabData[0]?.title1}</h3>}
                <div className={classes["sub-card-content-item-description"]} dangerouslySetInnerHTML={{ __html: filteredTabData[0]?.title1Desc ?? "" }}></div>
              </div>
              <div className={classes["sub-card-content-item"]}>
                {filteredTabData[0]?.title2 && <h3 className={classes["sub-card-content-item-title"]}>{filteredTabData[0]?.title2}</h3>}
                <div className={classes["sub-card-content-item-description"]} dangerouslySetInnerHTML={{ __html: filteredTabData[0]?.title2Desc ?? "" }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Elligibility;
